import { Controller } from "@hotwired/stimulus";
import A11yDialog from "a11y-dialog";

export default class extends Controller {
  static targets = ["modal", "modalOpen"];

  modalTargetConnected() {
    this.dialog = new A11yDialog(this.modalTarget);
  }

  modalOpenTargetConnected() {
    this.dialog = new A11yDialog(this.modalOpenTarget);

    this.dialog.show();

    $(this.dialog.$el).find('.select2').select2({
      width: 'resolve',
      dropdownParent: $(this.dialog.$el)
    });
  }

  show(event) {
    event.preventDefault();
    this.dialog.show();
  }

  hide(event) {
    event.preventDefault();
    this.dialog.hide();
  }
}
